module.exports = __webpack_public_path__ + "img/Character_Xiao_Thumb.e2240ab8.png";